<template>
  <div class="app-view-top-up-data">
    <slot name="txtBefore"></slot>
    <Single v-if="hasSingleTopUp" :topUpInfo="singleTopUpAmount" :changeBtn="false">
      <template v-for="slot in possibleChildSlotsFor('Single')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Single>
    <Monthly v-if="isMonthly" :topUpInfo="topUp" :changeBtn="false">
      <template v-for="slot in possibleChildSlotsFor('Monthly')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Monthly>
    <ByLimit v-if="isByLimit" :topUpInfo="topUp" :changeBtn="false">
      <template v-for="slot in possibleChildSlotsFor('ByLimit')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </ByLimit>
    <div class="no-top-up-summary" v-if="withoutTopUp">
      <slot name="noTopUpTxt"></slot>
    </div>
  </div>
</template>

<script>
import slotProxy from '@/mixins/slotProxy'
import { mapGetters } from 'vuex'
import Monthly from '@/components/process/FYVE/Activation/Summary/Monthly.vue'
import ByLimit from '@/components/process/FYVE/Activation/Summary/ByLimit.vue'
import Single from '@/components/process/FYVE/Activation/Summary/Single.vue'

export default {
  name: 'TopUpData',
  components: { Monthly, ByLimit, Single },
  computed: {
    ...mapGetters('orderProduct/topUp', [
      'topUp',
      'singleTopUpAmount',
      'hasSingleTopUp',
      'hasAutoTopUp',
      'hasTopUp',
      'withoutTopUp'
    ]),
    isMonthly () {
      return this.hasAutoTopUp && this.topUp.type === 'monthly'
    },
    isByLimit () {
      return this.hasAutoTopUp && this.topUp.type === 'byLimit'
    }
  },
  mixins: [
    slotProxy()
  ]

}
</script>
